<!-- Modal Component -->
<div
  class="modal fade show d-block kyc-modal"
  tabindex="-1"
  role="dialog"
  *ngIf="showModal && isSocketConnected"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content shadow-lg rounded-4 overflow-hidden">
      <form [formGroup]="popupForm" (ngSubmit)="onSubmit()">
        <div class="modal-header text-white gradient-header">
          <h5 class="modal-title m-0">
            <img
              src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/osp_logo_dark.png"
              alt="Logo"
              style="height: 32px"
            />
          </h5>
          <!-- <button type="button" class="btn-close-white" (click)="closeModal()">
              <span>&times;</span>
            </button> -->
        </div>

        <div class="modal-body">
          <p class="enter-code-label">Verify Your KYC</p>
          <div class="form-group mb-4">
            <label class="form-label">Aadhaar Card</label>
            <input
              type="tel"
              class="form-control input-glow"
              formControlName="aadhar"
              maxlength="12"
              (input)="onAadharInput($event)"
              (keypress)="onlyNumberKey($event)"
              placeholder="Enter 12-digit Aadhaar"
              [ngClass]="{
                'is-invalid':
                  (f['aadhar'].touched || f['aadhar'].dirty || submitted) &&
                  f['aadhar'].invalid
              }"
            />

            <small
              class="text-danger"
              *ngIf="f['aadhar'].errors?.['required'] && f['aadhar'].touched"
            >
              <b>Aadhaar is required</b>
            </small>

            <small
              class="text-danger"
              *ngIf="f['aadhar'].errors?.['pattern'] && f['aadhar'].touched"
            >
              <b>Invalid Aadhaar number. Must be 12 digits.</b>
            </small>
          </div>

          <div class="form-group mb-4">
            <label class="form-label">PAN Card</label>
            <input
              type="text"
              class="form-control input-glow"
              formControlName="pan"
              (keydown)="notAllowSpace($event)"
              maxlength="10"
              (input)="onPanInput($event)"
              placeholder="Enter PAN (e.g., ABCDE1234F)"
              [ngClass]="{
                'is-invalid':
                  (popupForm.get('pan')?.dirty ||
                    popupForm.get('pan')?.touched ||
                    submitted) &&
                  popupForm.get('pan')?.errors
              }"
            />

            <!-- Error Message -->
            <div
              class="error-message"
              *ngIf="
                (f['pan'].touched || f['pan'].dirty || submitted) &&
                f['pan'].errors
              "
            >
              <!-- this code needs to be removed in the next deployment -->
              <div *ngIf="f['pan'].errors?.['invalidFourthChar']">
                <b>4th character must be 'P'</b>
              </div>

              <div
                *ngIf="f['pan'].errors?.['pattern'] && !f['pan'].errors?.['invalidFourthChar']"
              >
                <b>Invalid PAN format</b>
              </div>

              <div *ngIf="f['pan'].errors?.['required']">
                <b>PAN is required</b>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-primary btn-lg w-100 rounded-pill gradient-button"
            (click)="submitKYC()"
            [disabled]="!isVliadOtp"
          >
            SUBMIT KYC
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showModal"></div>
<!-- ✅ Success Animation -->
<div *ngIf="showTick" class="tick-container">
  <div class="tick-circle">
    <div class="tick-mark"></div>
  </div>
  <div class="tick-message">
    Thank you for the details. Our executive will assist you further for your
    Commercial Vehicle Loan processing.
  </div>
</div>

<!-- ❌ Failure Animation -->
<div *ngIf="showReject" class="tick-container">
  <div class="tick-circle error">
    <div class="cross-mark"></div>
  </div>
  <div class="tick-message error-message">Failed! Please try again.</div>
</div>
<!-- ⏳ Link Expired Animation -->
<div *ngIf="showLinkExpired" class="tick-container-expired center-screen">
  <div class="tick-circle expired">
    <div class="exclamation-mark">!</div>
  </div>
  <div
    class="tick-message expired-message text-center mt-2"
    style="font-size: 22px"
  >
    Link Expired! Please request a new Link.
  </div>
</div>
